(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('@mui/material/FilledInput'), require('@mui/material/FormControl'), require('@mui/material/FormHelperText'), require('@mui/material/InputAdornment'), require('@mui/material/InputLabel'), require('@mui/material/styles')) :
    typeof define === 'function' && define.amd ? define(['react', '@mui/material/FilledInput', '@mui/material/FormControl', '@mui/material/FormHelperText', '@mui/material/InputAdornment', '@mui/material/InputLabel', '@mui/material/styles'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['@freska-fi/ui-input'] = factory(global.React, global.FilledInput, global.FormControl, global.FormHelperText, global.InputAdornment, global.InputLabel, global.styles));
}(this, (function (React, FilledInput, FormControl, FormHelperText, InputAdornment, InputLabel, styles) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var FilledInput__default = /*#__PURE__*/_interopDefaultLegacy(FilledInput);
    var FormControl__default = /*#__PURE__*/_interopDefaultLegacy(FormControl);
    var FormHelperText__default = /*#__PURE__*/_interopDefaultLegacy(FormHelperText);
    var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
    var InputLabel__default = /*#__PURE__*/_interopDefaultLegacy(InputLabel);

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function Input(props) {
        var theme = styles.useTheme();
        var classes = props.classes, id = props.id, name = props.name, type = props.type, defaultValue = props.defaultValue, label = props.label, placeholder = props.placeholder, onFocus = props.onFocus, onBlur = props.onBlur, onChange = props.onChange, value = props.value, autoComplete = props.autoComplete, _a = props.multiline, multiline = _a === void 0 ? false : _a, rows = props.rows, maxRows = props.maxRows, fullWidth = props.fullWidth, disabled = props.disabled, required = props.required, error = props.error, helperText = props.helperText, adornment = props.adornment, inputRef = props.inputRef, InputProps = props.InputProps, _b = props.disabledAdornment, disabledAdornment = _b === void 0 ? true : _b;
        var helperTextId = helperText && id ? id + "-helper-text" : undefined;
        var inputLabelId = label && id ? id + "-label" : undefined;
        return (React__default['default'].createElement(FormControl__default['default'], { classes: classes, variant: "filled", fullWidth: fullWidth },
            label && (React__default['default'].createElement(InputLabel__default['default'], { id: inputLabelId, htmlFor: id, variant: "filled", sx: {
                    color: theme.palette.text.disabled,
                    fontSize: 20,
                    transform: 'translate(16px, 18px) scale(1)',
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(16px, 10px) scale(0.75) !important',
                    },
                } }, label)),
            React__default['default'].createElement(FilledInput__default['default'], __assign({ "aria-describedby": helperTextId, id: id, name: name, type: type, defaultValue: defaultValue, placeholder: placeholder, onFocus: onFocus, onBlur: onBlur, onChange: onChange, value: value, autoComplete: autoComplete, multiline: multiline, rows: rows, maxRows: maxRows, disabled: disabled, required: required, error: error, endAdornment: adornment ? (React__default['default'].createElement(InputAdornment__default['default'], { position: "end", disablePointerEvents: disabledAdornment, sx: {
                        color: theme.palette.primary.main,
                        marginTop: '0px !important',
                        '& p': {
                            color: theme.palette.text.secondary,
                            fontSize: 20,
                        },
                    } }, adornment)) : null, inputRef: inputRef }, InputProps, { sx: {
                    '& .MuiInputBase-input': {
                        color: theme.palette.text.primary,
                        overflow: 'hidden',
                        marginTop: multiline && label ? "16px !important" : undefined,
                        paddingTop: (function () {
                            if (multiline)
                                return '0px';
                            if (label)
                                return '26px';
                            return '16px';
                        })(),
                        paddingBottom: (function () {
                            if (multiline)
                                return '0px';
                            if (label)
                                return '6px';
                            return '16px';
                        })(),
                        paddingLeft: (function () {
                            if (multiline)
                                return '4px';
                            return '16px';
                        })(),
                        paddingRight: (function () {
                            if (multiline)
                                return '4px';
                            return '16px';
                        })(),
                        fontSize: (function () {
                            if (props.multiline)
                                return '17px';
                            return '20px';
                        })(),
                        '&::placeholder': {
                            color: theme.palette.text.disabled,
                            opacity: 1,
                        },
                        '&:-webkit-autofill': {
                            borderRadius: 'inherit',
                        },
                        '&:before': {
                            border: 'none',
                        },
                    },
                } })),
            helperText && (React__default['default'].createElement(FormHelperText__default['default'], { id: helperTextId, error: error, sx: {
                    color: error ? theme.palette.error.main : theme.palette.text.secondary,
                } }, helperText))));
    }

    return Input;

})));
